import { Skeleton } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboard } from "../../store/dashboard/dashboardThunks";
import "./Dashboard.css";
import FocusCards from "./FocusCards";
import OverviewSection from "./OverviewSection";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { isLoading, data } = useSelector((s) => s.dashboard);

  useEffect(() => {
    dispatch(fetchDashboard());
  }, [dispatch]);

  return (
    // <Card className="body-card-content-no-min-height">
    <Skeleton active loading={isLoading && !data} paragraph={{ rows: 12 }}>
      <div className="dashboard">
        <FocusCards
          //
          focus={data?.focus}
          loading={isLoading}
          // className="body-card-content-no-min-height"
        />
        <OverviewSection
          overviewByTimeRange={data?.overviewByTimeRange}
          loading={isLoading}
        />
      </div>
    </Skeleton>
    // </Card>
  );
};

export default Dashboard;
